import actionTypes from './actions/actionTypes'

const {
  CHANGE_SUCCESS,
  GET_USERS_EXPIRED,
  GET_MA_EXPIRED,
  GET_ACTIVATION_EMAIL,
  MA_SIGNUP_EMAIL,
  GET_DOMAIN
} = actionTypes

const templateReducer = (
  state = {
    isUpdating: false,
    error: null,
    data:'',
    maData:'',
    emailData:''
  },
  action
) => {
  switch (action.type) {
    case CHANGE_SUCCESS:
      return Object.assign({}, state, {isUpdating: true})
    case GET_USERS_EXPIRED:
      return Object.assign({}, state, {data: action.data})
    case GET_MA_EXPIRED:
      return Object.assign({}, state, {maData: action.data})
    case GET_ACTIVATION_EMAIL:
      return Object.assign({}, state, {emailData: action.data}) 
    case MA_SIGNUP_EMAIL:
      return Object.assign({}, state, {signupData: action.data})
    case GET_DOMAIN:
      return Object.assign({}, state, {data: action.data})
    default:
      return state
  }
}

export default templateReducer



// WEBPACK FOOTER //
// src/routes/Domain/reducer.js